import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class ServiceNisStrService {
    get = this.i18nService.get;

    i18n = {
        configureBtn: this.get('common.configure_button'),
        resetBtn: this.get('settings.domainAuth_term_restoreInitConfig_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),
        operationBtn: this.get('common.operation_button'),
        testBtn: this.get('common.test'),

        vstoreLab: this.get('common.owningVstore_lab'),
        statusLab: this.get('common.status_column'),
        enabledLab: this.get('common.service_enable_value'),
        disabledLab: this.get('common.disabled_label'),
        domainLab: this.get('settings.domainAuth_term_NISDomain_domainName_lab'),
        primaryIpAddressLab: this.get('settings.domainAuth_term_ldapDomain_activeIP_label'),
        standbyIpAddressLab1: this.get('settings.domainAuth_term_ldapDomain_standbyIP1_label'),
        standbyIpAddressLab2: this.get('settings.domainAuth_term_ldapDomain_standbyIP2_label'),
        unconfigureLab: this.get('common.unconfigured_lab'),

        title: this.get('settings.domainAuth_term_NIS_lab'),
        detailTitle: this.get('settings.domainAuth_term_serviceNIS_tittle'),
        configureTitle: this.get('settings.domainAuth_term_configServiceNIS_tittle'),

        ipTip: this.get('common.IPv4orDomainName_label'),

        domainErr: this.get('settings.domainAuth_term_serviceNIS_domainName_validation'),
        ipErr: this.get('settings.domainAuth_term_serviceNIS_serverAddress_validation'),
        ipRepeatErr: this.get('common.duplicateAddress_label'),

        modifyResult: this.get('rest.modifyServiceNISSetting'),
        deleteResult: this.get('rest.initiaServiceNISSetting'),

        configureMsg: this.get('settings.systemSetting_task_configNIS_info_msg'),
        resetMsg: this.get('settings.systemSetting_task_restoreNisConfig_info_msg'),
        configServiceNIS: this.get('service.vstore_domainAuth_term_configServiceNIS_tittle'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }
}
